import React from 'react'
import { Flag, Swords, Brain, BarChart3, User } from 'lucide-react'
import { tr, useLang } from '../games/lib/lang.js'

export function BottomNav({ activeTab = 'train', onTabChange }) {
  const [lang] = useLang()
  const tabs = [
    { id: 'missions', label: tr(lang, 'Misiones', 'Missions'), icon: Flag },
    { id: 'duels', label: tr(lang, 'Duelos', 'Duels'), icon: Swords },
    { id: 'train', label: tr(lang, 'Entrenar', 'Train'), icon: Brain, highlight: true },
    { id: 'ranking', label: tr(lang, 'Ranking', 'Ranking'), icon: BarChart3 },
    { id: 'profile', label: tr(lang, 'Perfil', 'Profile'), icon: User },
  ]

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0a0d14]/95 backdrop-blur-xl border-t border-slate-800/80 px-2 py-1.5 max-w-md mx-auto">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange?.(tab.id)}
              className={`flex flex-col items-center justify-center py-1 px-3 rounded-xl transition-all cursor-pointer ${
                isActive
                  ? 'text-amber-300 font-bold'
                  : 'text-slate-400 hover:text-slate-200'
              }`}
            >
              <div
                className={`relative p-1 rounded-full transition-all ${
                  isActive && tab.highlight
                    ? 'bg-amber-500/10 text-amber-300 shadow-[0_0_12px_rgba(245,158,11,0.4)]'
                    : ''
                }`}
              >
                <Icon size={20} className={isActive ? 'stroke-[2.5]' : 'stroke-2'} />
              </div>
              <span className="text-[10px] mt-0.5 tracking-tight">{tab.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
